import React from "react"
import styled from "styled-components"
import useInject from "~/hooks/useInject"
import PropTypes from "prop-types";

const CheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
`

const CheckboxContainerParkingCheckout = styled.div`
  display: inline-block;
  vertical-align: middle;
  padding-bottom: 60px;
`

const Icon = styled.svg`
  fill: none;
  stroke: ${(props) => props.theme.colors.primary};
  stroke-width: 3px;
`

const HiddenCheckbox = styled.input.attrs({ type: "checkbox" })`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`

const StyledCheckbox = styled.div`
  display: inline-block;
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  background: #ffffff;
  border-radius: 4px;
  border: solid 1px
    ${(props) =>
      props.error
        ? props.theme.colors.error
        : props.theme.colors.ui.inputBorder};
  transition: all 150ms;
  cursor: pointer;
  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 3px ${(props) => props.theme.colors.primary};
  }
  ${Icon} {
    visibility: ${(props) => (props.checked ? "visible" : "hidden")};
  }
`

const mapStore = store => ({
  isPayFlow:  store.parkingFlow.flow.isPayFlow
})

const Checkbox = ({ checked, size, error, ...props }) => {

  const { isPayFlow } = useInject(mapStore)

  return isPayFlow ? (
    <CheckboxContainerParkingCheckout>
      <HiddenCheckbox checked={checked} {...props} />
      <StyledCheckbox size={size} checked={checked} error={error} {...props}>
        <Icon viewBox="0 0 24 24">
          <polyline points="20 6 9 17 4 12" />
        </Icon>
      </StyledCheckbox>
    </CheckboxContainerParkingCheckout>
    ) : (
      <CheckboxContainer>
        <HiddenCheckbox checked={checked} {...props} />
        <StyledCheckbox size={size} checked={checked} error={error} {...props}>
          <Icon viewBox="0 0 24 24">
            <polyline points="20 6 9 17 4 12" />
          </Icon>
        </StyledCheckbox>
      </CheckboxContainer>
      )}

Checkbox.defaultProps = {
  size: 27,
  checked: false,
  onChange: () => {},
}
Checkbox.propTypes = {
  size: PropTypes.number,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
}

export default Checkbox
